module.exports = __webpack_public_path__ + "img/6-full-lg.17be3d39.jpg";